module.exports = {"id":"204372","name":"Emrah Başsan","rating":"71","photo":"./data/images/photos/0/204372.png","club":{"name":"Vitoria Setúbal","logo":"./data/images/clubs/VitoriaSetubal.png"},"positions":["MD","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EmrahBassan0.json
// module id = 1244
// module chunks = 0